<script setup>
  // import { computedAsync } from '@vueuse/core'
  import { ref, watchEffect, defineEmits } from 'vue'
  import TextWithDefinitions from './TextWithDefinitions.vue'
  import { useTemplateVariablesStore } from '../stores/TemplateVariablesStore'
  import { storeToRefs } from 'pinia'

  const templateStore = useTemplateVariablesStore()
  const { getDefinitionById } = templateStore
  const { loading } = storeToRefs(templateStore)
  const props = defineProps(['text', 'variables', 'isCenterModal', 'isLandingPage'])
  const emit = defineEmits(['update:completeText'])

  const completeText = ref('')
  watchEffect(async () => {
    let text = await getDefinitionById(props.text, '', props.variables, '', props.isLandingPage ? true : false)
    completeText.value = text.body
    emit('update:completeText', completeText.value)
  })
</script>

<template>
  <!-- Show skeleton loader while loading -->
  <div v-if="loading" class="d-flex flex-column">
    <div class="placeholder-glow">
      <span class="placeholder col-6"></span>
    </div>
    <div class="placeholder-glow">
      <span class="placeholder col-4"></span>
    </div>
    <div class="placeholder-glow">
      <span class="placeholder col-5"></span>
    </div>
  </div>
  
  <!-- Show actual content when not loading -->
  <TextWithDefinitions
    v-else
    :key="completeText"
    :text="completeText"
    :isCenterModal="!!props.isCenterModal" />
</template>

<style scoped></style>
